/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var ArrayTrajectory = /** @class */ (function () {
    function ArrayTrajectory(frames) {
        this.frames = frames;
        this.frameCount = frames.length;
        this.representative = frames[0];
        this.duration = frames.length;
    }
    ArrayTrajectory.prototype.getFrameAtIndex = function (i) {
        return this.frames[i];
    };
    return ArrayTrajectory;
}());
export { ArrayTrajectory };
//# sourceMappingURL=trajectory.js.map